var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-spinner'),(_vm.getCampaignContent)?_c('iframe',{attrs:{"id":"template-iframe"}}):_vm._e(),(!_vm.getLoadingStatus && (!_vm.getCampaignContent || _vm.getCampaignContent === ""))?_c('empty-state',{attrs:{"icon":"browser","description":"No Template has been associated to this campaign"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }